import IndustryChecklistI18n from "@/components/landing/shared/IndustryChecklistI18n";
const ChecklistECommerceSection = () => <IndustryChecklistI18n translationPrefix="industryECommerce" />;
export default ChecklistECommerceSection;
